import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import websiteActions from '../../redux/websites/actions';
import WebsitesList from '../../components/WebsitesList';
import SidebarContainer from '../SidebarContainer';
import './Websites.scss';

function Websites({ websites, actions }) {
  useEffect(() => {
    actions.websitesLightRequest();
  }, [actions]);

  const onDelete = websiteId => {
    actions.deleteWebsiteRequest(websiteId);
  };

  return (
    <SidebarContainer title="Websites" openSubMenu="Client Management">
      <div className="websites-table">
        <WebsitesList list={websites.websites} onDelete={onDelete} />
      </div>
    </SidebarContainer>
  );
}

Websites.propTypes = {
  websites: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ websites }) => ({ websites });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...websiteActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Websites);
